import axios from "axios"
import {
  contactosSelector,
  getAllContactosOptionsSelector,
  getAllContactosSelector,
  getContactosBySelectSelector,
  getContactosSelector,
} from "features/Contactos/redux/selectors/contactoSelectors"
import {
  fetchAllContactos,
  fetchContactosByFilters,
  fethContactosBySelectFilter,
  getContacto,
  getContactoAndEdit,
  hasContactoContactoPendingValidations,
  setPaginationIsNeeded,
  toggleIsContactCreated,
  toggleShowCreateContactoModal,
  toggleShowEditContactoModal,
  updateContactosFilters,
} from "features/Contactos/redux/slices/contactoSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useCallback } from "react"
import { useHistory } from "react-router-dom"
import mapContactoFromApi from "../mappers/mapContactoFromApi"

const useContactos = (setContacto: $TSMigrationFixMe) => {
  const contactos = useSelector(getContactosSelector)
  const allContactos = useSelector(getAllContactosSelector)
  const {
    contacto,
    fetchingContacto,
    fetchingContactos,
    showEditContactoModal,
    showCreateContactoModal,
    currentContacto,
    totalCount,
    fetchingContactosBySelect,
    isContactCreated,
  } = useSelector(contactosSelector)
  const allContactosOptions = useSelector(getAllContactosOptionsSelector)
  const contactosBySelect = useSelector(getContactosBySelectSelector)
  const dispatch = useDispatch()

  const history = useHistory()
  const redirecToEdit = (id: $TSMigrationFixMe) => {
    const path = `/contactos/${id}`
    history.push(path)
  }

  const editCliente = async (
    id: $TSMigrationFixMe,
    paginationNeeded = false,
    isFacturaRecurrente: $TSMigrationFixMe,
    contacto: $TSMigrationFixMe
  ) => {
    if (isFacturaRecurrente) {
      const {
        data: { items = [] },
      } = await axios.get(`/Contacto/by-filters-simple?Cif=${contacto?.nif}`)
      if (!items[0]) return
      dispatch(getContactoAndEdit(items[0]?.id))
      redirecToEdit(items[0]?.id)
    } else {
      dispatch(getContactoAndEdit(id))
      redirecToEdit(id)
    }
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setPaginationIsNeeded(paginationNeeded))
  }

  const editProveedor = (id: $TSMigrationFixMe) => {
    dispatch(getContactoAndEdit(id))
  }

  const editContacto = async (
    id: $TSMigrationFixMe,
    paginationNeeded = false,
    isFacturaRecurrente: $TSMigrationFixMe,
    contacto: $TSMigrationFixMe,
    isCliente: $TSMigrationFixMe
  ) => {
    if (isCliente) {
      editCliente(id, paginationNeeded, isFacturaRecurrente, contacto)
    } else {
      editProveedor(id)
    }
  }

  const getContactosByFilters = useCallback(
    (param: $TSMigrationFixMe) => {
      dispatch(fetchContactosByFilters(param))
    },
    [dispatch]
  )

  const getAllContactos = useCallback(() => {
    dispatch(fetchAllContactos())
  }, [dispatch])

  const toggleShowCreateContacto = (paginationNeeded = false) => {
    dispatch(toggleShowCreateContactoModal())
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(setPaginationIsNeeded(paginationNeeded))
  }

  const toggleIsContactCreatedDispatch = () =>
    dispatch(toggleIsContactCreated())

  const toggleShowEditContacto = () => dispatch(toggleShowEditContactoModal())

  const setContactosFilters = (filters: $TSMigrationFixMe) => {
    dispatch(updateContactosFilters(filters))
    // @ts-expect-error TS(2345): Argument of type...
    dispatch(fetchContactosByFilters())
  }

  const getContactosBySelect = (param: $TSMigrationFixMe) => {
    dispatch(fethContactosBySelectFilter(param))
  }
  const getContactoById = useCallback(
    (id: $TSMigrationFixMe, handleGetContacto: $TSMigrationFixMe) => {
      dispatch(getContacto({ id, handleGetContacto }))
    },
    [dispatch]
  )

  const handleGetContacto = useCallback(
    (contacto: $TSMigrationFixMe) => {
      if (setContacto) {
        const mappedLibrado = mapContactoFromApi(contacto)
        return dispatch(setContacto(mappedLibrado))
      }
    },
    [dispatch, setContacto]
  )

  const handleSelectContacto = useCallback(
    (e: $TSMigrationFixMe) => {
      getContactoById(e.target.value.id, handleGetContacto)
    },
    [getContactoById, handleGetContacto]
  )

  const checkContactoPendingValidations = (empresaId: $TSMigrationFixMe) => {
    dispatch(hasContactoContactoPendingValidations(empresaId))
  }

  return {
    allContactos,
    contacto,
    contactos,
    fetchingContacto,
    showEditContactoModal,
    showCreateContactoModal,
    fetchingContactos,
    totalCount,
    currentContacto,
    allContactosOptions,
    toggleShowCreateContacto,
    toggleShowEditContacto,
    getAllContactos,
    getContactosByFilters,
    setContactosFilters,
    editContacto,
    getContactosBySelect,
    contactosBySelect,
    fetchingContactosBySelect,
    getContactoById,
    handleSelectContacto,
    checkContactoPendingValidations,
    isContactCreated,
    toggleIsContactCreatedDispatch,
  }
}

export default useContactos
